module.exports = __webpack_public_path__ + "static/media/test.20f14554.jpg";